import { NextPage } from 'next';

interface ErrorPageProps {
  statusCode?: number | null | undefined;
}

/**
 * Rendered for 500 errors on both server and client. Used only in Production mode.
 * @link https://nextjs.org/docs/advanced-features/custom-error-page#more-advanced-error-page-customizing
 */
const ErrorPage: NextPage<ErrorPageProps> = () => (
  <div className="container flex flex-col items-center gap-2 py-24">
    <h1 className="text-[5rem] font-bold leading-none text-yellow">500</h1>
    <p className="text-[1.2rem] font-bold">Internal Server Error</p>
    <p className="text-[1.2rem]">We apologize for inconvenience, please try again later</p>
  </div>
);

export default ErrorPage;
